import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13a8ee38")

_pushScopeId("data-v-13a8ee38")
const _hoisted_1 = { class: "bg-screen min-h-screen" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createVNode(_component_router_view, null, {
      default: _withId(({ Component }) => [
        _createVNode(_Transition, {
          name: "scale",
          mode: "out-in"
        }, {
          default: _withId(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
})